// extracted by mini-css-extract-plugin
module.exports = {"body":"partners_body__1VvMF","thanks":"partners_thanks__n1C6i","jumbotron":"partners_jumbotron__2-Fkd"};